import { render, staticRenderFns } from "./tcustbase-add-or-updatee.vue?vue&type=template&id=9a10bc3c&scoped=true&"
import script from "./tcustbase-add-or-updatee.vue?vue&type=script&lang=js&"
export * from "./tcustbase-add-or-updatee.vue?vue&type=script&lang=js&"
import style0 from "./tcustbase-add-or-updatee.vue?vue&type=style&index=0&id=9a10bc3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a10bc3c",
  null
  
)

export default component.exports